<template>
   <div>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="2" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
                  :tabslist="tabForm">
                  <template slot="tabs" slot-scope="scope">
                     <!-- 主要信息 -->
                     <div v-if="scope.index == 0">
                        <el-form v-if="formDataList.length > 0" label-width="110px" id="mainInfo" class="baseForm"
                           :show-message="false" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                           <el-row>
                              <el-form-item label="" v-if="formOneValue.isShow == 1"
                                 v-for="(formOneValue, formOneKey) in formDataList[0].jurconfigform" :key="formOneKey">
                                 <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                    v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                 <span>{{ sendDataInfo[formOneValue.entityField] }}</span>
                              </el-form-item>
                           </el-row>
                        </el-form>
                        <!-- 明细 -->
                        <el-form :inline="true" size="mini" v-if="formDataList.length > 0 && formDataList.length >= 2">
                           <!-- actionData.cate!=2?(mxHeight/2): -->
                           <el-alert title="商品信息" type="success" :closable="false" effect="dark"></el-alert>
                           <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.consumeDetailVoList"
                              border style="width: 100%;margin-bottom:10px;" :height="mxHeight" @row-click="rowClick">
                              <el-table-column v-if="formOneValue.isShow == 1" align="center"
                                 v-for="(formOneValue, tableKey) in formDataList[1].jurconfigform" :key="tableKey"
                                 :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip
                                 :min-width="formOneValue.fieldWeight">
                                 <template slot-scope="scope">
                                    <span v-if="formOneValue.fieldType == 'date'">
                                       <span v-if="scope.row[formOneValue.entityField]">
                                          {{ $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else>{{ scope.row[formOneValue.entityField] }}</span>
                                 </template>
                              </el-table-column>
                           </el-table>
                        </el-form>
                        <!-- <el-form v-if="formDataList.length>0&&formDataList.length>=3">
                           <el-alert v-if="actionData.cate!=2" title="UDI信息" type="success" :closable="false" effect="dark"></el-alert>
                           <el-table v-if="actionData.cate!=2" size="mini" ref="mxTableRef1" id="mxTable1" :data="sendDataInfo.udiDetailVoList" border style="width: 100%" :height="mxHeight/2">
                              <el-table-column v-if="formOneValue.isShow == 1" v-for="(formOneValue, tableKey) in formDataList[2].jurconfigform" :key="tableKey" :prop="formOneValue.entityField"
                                               :label="formOneValue.showField" show-overflow-tooltip :min-width="formOneValue.fieldWeight">
                                 <template slot-scope="scope">
                                    <span v-if="formOneValue.fieldType == 'date'">
                                       <span v-if="scope.row[formOneValue.entityField]">
                                          {{  $common.getLocalTime(scope.row[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else>{{  scope.row[formOneValue.entityField]}}</span>
                                 </template>
                              </el-table-column>
                           </el-table>
                        </el-form> -->
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <!-- 页脚 -->
            <div class="foot1">
               <el-form :inline="true" class="demo-form-inline ml">
                  <el-form-item label="总金额">
                     <span class="number">{{ sendDataInfo.totalMoney }}</span>
                  </el-form-item>
                  <el-form-item label="总数量">
                     <span class="number">{{ sendDataInfo.totalNumber }}</span>
                  </el-form-item>
               </el-form>
               <div class="sureButton" v-if="actionData.cate != 2">
                  <el-button @click="initActionBox('sendDataInfo')">取消</el-button>
                  <el-button type="primary" @click="sendDataAction(1)">同意</el-button>
                  <el-button type="primary" @click="sendDataAction(0)">不同意</el-button>
               </div>
            </div>
         </div>
      </div>
      <el-dialog title="确认消耗单" center :visible.sync="consumeShow" append-to-body>
         <el-form :model="consumeObj" label-position="top">
            <el-form-item label="确认状态">
               <el-radio-group v-model="consumeObj.confirmState">
                  <el-radio-button :label="1">同意</el-radio-button>
                  <el-radio-button :label="0">不同意</el-radio-button>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="确认原因">
               <el-input type="textarea" placeholder="请输入内容" v-model="consumeObj.remark" maxlength="200"
                  show-word-limit>
               </el-input>
            </el-form-item>
         </el-form>
         <div slot="footer" class="dialog-footer">
            <el-button @click="consumeShow = false">取 消</el-button>
            <el-button type="primary" @click="confirmData()">确 定</el-button>
         </div>
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>
</template>

<script>
export default {
   name: "consumeConfirmAction",
   props: ["actionData"],
   data() {
      return {
         mxHeight: 300,
         dataActionBox: {
            actionType: 2
         },
         showTabs: "消耗单确认信息",
         tabForm: [
            {
               isShowForm: 0,
               jciName: "消耗单确认信息",
            }
         ],
         selectDataIndex: 0,
         formDataList: [],
         sendDataInfo: {},
         //------------------
         consumeShow: false,
         consumeObj: {
            cosumId: "",
            confirmState: 1,
            remark: "",
         }
      }
   },
   created() {
      this.$nextTick(() => {
         this.openBox();
      });
   },
   methods: {
      rowClick(row) {
         this.selectDataIndex = this.sendDataInfo.consumeDetailVoList.indexOf(row)
         this.sendDataInfo.udiDetailVoList = row.udiDetailVoList
      },
      openBox() {
         this.sendDataInfo = JSON.parse(JSON.stringify(this.actionData.oldData));
         this.formDataList = JSON.parse(JSON.stringify(this.actionData.formData))
         this.selectDataIndex = 0
         this.$set(this.sendDataInfo, "udiDetailVoList", this.sendDataInfo.consumeDetailVoList[this.selectDataIndex].udiDetailVoList)
         this.$nextTick(() => {
            setTimeout(() => {
               this.mxHeight = this.$common.getBtnHeight() - 70
            }, 16.7)
         });
      },
      initActionBox() {
         this.$emit("drawerCancel");
      },
      sendDataAction(val) {
         this.consumeObj.cosumId = this.sendDataInfo.cosumId
         this.consumeObj.confirmState = val
         if (val === 1) {
            this.confirmData()
         } else {
            this.$prompt('请输入原因', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
            }).then(({ value }) => {
               this.consumeObj.remark = value
               this.confirmData()
            }).catch(() => {});
         }
      },
      // 确认消耗单
      async confirmData() {
         var confirmData = JSON.parse(JSON.stringify(this.consumeObj))
         let responseData = await this.$http.consumeAdminConfirm(confirmData)
         if (responseData.status == 200) {
            this.$message({
               type: 'success',
               message: '确认成功!'
            });
            this.consumeShow = false
            this.$emit("drawerCancel", true);
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      showPrintPlan() { },
   },
}
</script>

<style scoped>
.foot1 {
   display: flex;
   /* justify-content: center; */
   align-items: center;
   width: 100%;
   background: #fff;
   height: 46px;
   padding: 5px 10px;
   z-index: 999;
   position: fixed;
   bottom: 0;
   left: 0;
   box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.sureButton {
   position: absolute;
   left: 50%;
   transform: translateX(-50%);
}

.number {
   color: red;
   font-size: 18px !important;
   background: none;
   border: none;
}

::v-deep .el-alert {
   width: 100%;
   height: 30px;
   line-height: 30px;
   padding: 0 !important;
   font-weight: 700;
   font-size: 16px;
}
</style>